import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.OverviewPage.components.BulkAddTasks.title',
    defaultMessage: 'Bulk add tasks',
  },
})
